import { useEffect, useState } from "react";
import axios from "axios";

export default function DeleteUser() {

  const [users, setUsers] = useState([]);
  const [msg, setMsg] = useState("");
const token = localStorage.getItem("token"); 

  //search 
  const [search, setSearch] = useState("");


  const loadUsers = () => {
    axios
      .get(`/api/clients`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => setUsers(res.data))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const deleteUser = (id) => {

    if (!window.confirm("Da li sigurno želiš da obrišeš klijenta?")) return;

    axios
      .delete(`/api/clients/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(() => {
        setMsg("Klijent obrisan ✅");
        loadUsers(); // refresh lista
      })
      .catch(() => setMsg("Greška pri brisanju ❌"));
  };


    // Filtrirana lista po search inputu
    const s = search.toLowerCase();

    const filteredUsers = (users || []).filter(u =>
      (u?.ime || "").toLowerCase().includes(s) ||
      String(u?.klijentID || "").includes(search) ||
      (u?.adresa || "").toLowerCase().includes(s) ||
      (u?.email || "").toLowerCase().includes(s) ||
      (u?.grad || "").toLowerCase().includes(s) ||
      (u?.telefon || "").toLowerCase().includes(s)
    );

  return (
    <div className="card bg-dark text-white p-4">
      <h4>Delete klijent</h4>

      {/* LOKALNI SEARCH */}
      <input
        type="text"
        className="form-control mb-3 w-25"
        placeholder="Search by ID or name..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />


      {msg && <p>{msg}</p>}

      <table className="table table-dark mt-3">
        <thead>
          <tr>
            <th>ID</th>
            <th>Ime</th>
            <th>Email</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {filteredUsers.map(u => (
            <tr key={u.klijentID}>
              <td>{u.klijentID}</td>
              <td>{u.ime}</td>
              <td>{u.email}</td>
              <td>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => deleteUser(u.klijentID)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}